
import {Vue, Component, Watch} from 'vue-property-decorator';
import SayfaAciklama from "@/components/SayfaAciklama.vue";
import ReferansSelect from "@/components/pickers/ReferansSelect.vue";
import * as XLSX from 'xlsx';
import TopluKartEkleme from "@/classes/topluTakip/TopluKartEkleme";
import BorcluBilgileri from "@/classes/topluTakip/BorcluBilgileri";
import AlacakliBilgileri from "@/classes/topluTakip/AlacakliBilgileri";
import DosyaBilgileri from "@/classes/topluTakip/DosyaBilgileri";
import AlacakKalemiBilgileri from "@/classes/topluTakip/AlacakKalemiBilgileri";
import {FaizTuruLabel} from "@/enum/FaizTuruLabel";
import {satiriDogrula, enumAlanlariNormalizeEt, SUTUN_KURALLARI} from "@/classes/topluTakip/excelSema";
import {parseTarih, cinsiyetNormalize, parFloat} from "@/classes/topluTakip/excelDogrula";
interface ExcelHeader {
  field: string;
  callback?: (value: any) => any;
}

/**
 * Excel şablonunda faiz türü SIRA numarası olarak yazılır (1=Yasal Faiz, 2=Avans Faizi …).
 * Backend ise faizi İSİM ile çözüyor. Parse sırasında sırayı isme çeviririz; böylece hem eski
 * şablonlar çalışmaya devam eder hem gönderilen değer backend'in beklediği biçime uyar.
 * Sayı değilse (kullanıcı ismi yazmışsa) değere dokunulmaz.
 */
function faizSirasiniIsmeCevir(deger: any): string {
  if (deger === null || deger === undefined) return '';
  const s = String(deger).trim();
  if (s === '') return '';
  if (/^\d+$/.test(s)) {
    const isim = (FaizTuruLabel as any)[Number(s)];
    if (typeof isim === 'string' && isim !== '') return isim;
  }
  return s;
}

@Component({
  components: {SayfaAciklama, ReferansSelect}
})
export default class TopluExcelTakip extends Vue {
  downloading = false;

  excelFile: File | null = null;
  listTable = false
  tooltipInfo = false
  disableTopluTakip = false
  durumTable = false
  fileName: string = "";
  items: any[] = [];
  // Satır index'i → hata listesi (OBJE; dizi değil — silme/ekleme sonrası baştan kurulur).
  eksikAlanlar: any = {}
  kontrolItems: any = [];
  excelHeaders: any= {};
  dragover= false
  loadingAktar = false
  create :string = ''
  e1 = 1
  tamamlananDosyalar = 0
  siradaDosyalar = 0
  hataliDosyalar = 0
  isDragOver = false
  intervalId: any = null;
  // Aktarımın başlamasını bekleme sayacı (cron ~1 dk'da bir → başlamadan önceki bekleme süresi).
  sayacIntervalId: any = null;
  gecenSaniye = 0;
  // Kullanici "Arka planda devam et" dediyse: overlay kapanir ama yoklama surer,
  // is bitince bildirilir. Aktarim sunucu tarafinda kuyrukta oldugu icin iptal olmaz.
  arkaPlandaTakip = false;
  faizTuruLabel = FaizTuruLabel
  // Hangi hücrenin düzenlendiği: {index, alan} veya null (düzenleme kapalı).
  duzenlenen: {index: number, alan: string} | null = null
  // Satır düzenleme modalında açık olan satırın index'i (null = modal kapalı).
  satirModalIndex: number | null = null
  // Toplu değiştir çubuğu: seçili alan + uygulanacak değer.
  topluAlan: string = ''
  topluDeger: any = null
  // Toplu degistirmede takip yolu "DIGER" secilirse tum satirlara yazilacak aciklama.
  topluManuelYolu: string = ''

  // Excel'in standart sütunlarından SONRA gelen son sütunlar ek-alandır.
  // Şablonda başlıkları "Ek Alan 1..6"; kullanıcı istediği isimle değiştirebilir.
  // Excel'de yazan gerçek başlık ek-alan adı olarak alınır (max 6).
  ekAlanMax = 6;
  // Yüklenen excel'den tespit edilen ek-alan başlıkları (gösterim için)
  ekAlanBasliklari: string[] = [];

  // --- Referans alanları (DEV-2784): icraproweb listelerinden select ile beslenen sütunlar ---
  // Endpoint'ler tekli takip ekranındaki picker'larla aynı; sunucu + istemci tarafında cache'li.
  // metinAlan: kullanıcıya gösterilecek alan · degerAlan: hücreye/payload'a yazılacak alan.
  // serbestMetin=true (ör. icra_dairesi): metin gönderilir, listede olmayan değer elle yazılabilir
  //   (backend'in ozel_icra_dairesi_isim fallback'i korunur) → combobox.
  // serbestMetin=false (ör. takip_tipi): sayısal id gönderilir, isim gösterilir, serbest metne izin yok
  //   → autocomplete.
  // kodAlan (opsiyonel): gösterimde ismin yanında parantez içinde kod gösterilir ("İlamsız Takipler (7)",
  //   "İstanbul (34)"). Salt-görsel — gönderilen değer (degerAlan) değişmez; arama koda da bakar.
  readonly referansKaynaklari: Record<string, {endpoint: string, metinAlan: string, degerAlan: string, serbestMetin: boolean, kodAlan?: string}> = {
    icra_dairesi: {endpoint: '/api/v1/icra-dairesi/', metinAlan: 'isim', degerAlan: 'isim', serbestMetin: true},
    // il: isim gönderilir (backend Sehir::isim birebir eşler), 81 şehir → serbest metne izin yok; plaka gösterilir.
    borclu_il:    {endpoint: '/api/v1/sehir',         metinAlan: 'isim', degerAlan: 'isim', serbestMetin: false, kodAlan: 'kod'},
    // Faiz türleri: TENANT'IN KENDİ listesinden beslenir ve İSİM gönderilir — backend faiz türünü
    // isimle çözüyor. (Sabit enum kullanmak, tenant'ta olmayan isimler üretip faizin sessizce
    // yanlış kaydedilmesine yol açıyordu.)
    takip_oncesi_faiz_turu:  {endpoint: '/api/v1/faiz-turu-picker', metinAlan: 'isim', degerAlan: 'isim', serbestMetin: false},
    takip_sonrasi_faiz_turu: {endpoint: '/api/v1/faiz-turu-picker', metinAlan: 'isim', degerAlan: 'isim', serbestMetin: false},
  };
  // Takip tipi şimdilik yalnız İlamsız (Örnek 7 / 49) destekleniyor → hücre kilitli, düzenlenemez.
  // Diğer türler her biri kendi zorunlu alan setini gerektirdiği için ayrı bir işte ele alınacak.
  readonly kilitliAlanEtiketleri: Record<string, string> = {
    takip_tipi: 'İlamsız Takipler',
  };
  // Kilitli alanın zorunlu kıldığı değer. Hücre düzenlenemediği için Excel'den boş/hatalı gelen
  // değer kullanıcıyı çıkmaza sokardı (doğrulama hata verir, düzeltilemez) — parse sırasında
  // kanonik değere sabitlenir. 49 = Örnek 7 / İlamsız (backend zaten tüm değerleri buna maplıyor).
  readonly kilitliAlanDegerleri: Record<string, any> = {
    takip_tipi: 49,
  };
  // Yüklenen referans listeleri: alan → {text: gösterim, value: gönderilecek} dizisi.
  referansSecenekleri: Record<string, {text: string, value: any}[]> = {};

  // İlçe il'e bağımlı: borclu_ilce ayrı ele alınır (borclu_il'in sehir_id'sine göre /sehir/{id}/ilce).
  // İl isim → sehir_id haritası (borclu_il yüklenirken doldurulur).
  sehirAdIdMap: Record<string, any> = {};
  // İlçe listeleri sehir_id'ye göre cache'lenir (dropdown açılınca tembel yüklenir).
  ilceCache: Record<string, {text: string, value: any}[]> = {};
  ilceYuklePromise: Record<string, Promise<void>> = {};

  // Statik referanslar: DB'den değil, sabit küçük listeler (göster ≠ gönder).
  // cinsiyet: kullanıcıya ERKEK/KADIN gösterilir, backend'e E/K gider (backend 'E'?erkek:kadin).
  readonly referansStatik: Record<string, {text: string, value: any}[]> = {
    borclu_cinsiyet: [
      {text: 'ERKEK', value: 'E'},
      {text: 'KADIN', value: 'K'},
    ],
  };

  // TakipEkAlanTuruForm.formatName ile birebir: tr karakter map + boşluk->_ + lowercase
  ekAlanKod(isim: string): string {
    const searchChar = ['ç', 'ğ', 'ş', 'ü', 'ı', 'ö', ' '];
    const replaceChar = ['c', 'g', 's', 'u', 'i', 'o', '_'];
    let name = (isim || '').toLowerCase();
    for (let i = 0; i < searchChar.length; i++) {
      name = name.replace(new RegExp(searchChar[i], 'g'), replaceChar[i]);
    }
    return name;
  }

  // JS Date -> ISO YYYY-MM-DD (yerel takvim günü; saat kısmı atılır).
  dateToIso(d: Date): string | null {
    if (!(d instanceof Date) || isNaN(d.getTime())) return null;
    const yyyy = d.getFullYear();
    const mm = (d.getMonth() + 1).toString().padStart(2, '0');
    const dd = d.getDate().toString().padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  // Excel tarih seri numarasını saat dilimine hiç çevirmeden takvim gününe çözer.
  // XLS/XLSX tarihlerini Date objesine çevirmek bazı saat dilimlerinde günü bir gün geri
  // kaydırıyordu. SSF çözümü doğrudan Excel'in yıl/ay/gün parçalarını verir.
  excelTarihSerialToIso(value: number, date1904 = false): string | null {
    if (typeof value !== 'number' || !isFinite(value)) return null;
    const parsed: any = XLSX.SSF.parse_date_code(value, {date1904});
    if (!parsed || !parsed.y || !parsed.m || !parsed.d) return null;

    const check = new Date(Date.UTC(parsed.y, parsed.m - 1, parsed.d));
    if (check.getUTCFullYear() !== parsed.y || check.getUTCMonth() !== parsed.m - 1 || check.getUTCDate() !== parsed.d) {
      return null;
    }

    const yyyy = String(parsed.y).padStart(4, '0');
    const mm = String(parsed.m).padStart(2, '0');
    const dd = String(parsed.d).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  // Ek-alan değerini tarih olarak çözmeyi dener.
  // Desteklenen girişler:
  //   - Date objesi (eski çağrılarla geriye uyumluluk için)
  //   - "5.06.2026", "05.06.2026", "5/6/2026", "5-6-2026"
  //   - "5.06.2026 10:35:41" gibi saat ekli varyantlar (saat yok sayılır)
  // Başarılıysa ISO (YYYY-MM-DD) döner; değilse null (tarih değil -> text).
  // ÖNEMLİ: Düz number (ör. 251), hücrenin Excel biçimi tarih olduğunu göstermedikçe
  // TARİH SAYILMAZ; aksi halde "Agent" gibi sayısal ek alanlar tarihe çevrilirdi.
  parseEkAlanTarih(value: any, excelTarihHucresi = false, date1904 = false): string | null {
    if (value === null || value === undefined || value === '') return null;

    // Gerçek tarih hücresi: XLSX cellDates:true -> Date objesi.
    if (value instanceof Date) {
      return this.dateToIso(value);
    }

    // Sayı yalnız kaynak Excel hücresinin biçimi tarihse seri tarih olarak çözülür.
    if (typeof value === 'number') {
      return excelTarihHucresi ? this.excelTarihSerialToIso(value, date1904) : null;
    }

    const str = String(value).trim();
    if (str === '') return null;

    // Tarih kısmını al (varsa saatten önce). Ayraç: . / -
    const datefPart = str.split(/[ T]/)[0];
    const m = datefPart.match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})$/);
    if (!m) return null;

    const gun = parseInt(m[1], 10);
    const ay = parseInt(m[2], 10);
    const yil = parseInt(m[3], 10);

    if (ay < 1 || ay > 12 || gun < 1 || gun > 31) return null;
    // Geçerli takvim günü doğrulaması (ör. 31.02 ele)
    const check = new Date(Date.UTC(yil, ay - 1, gun));
    if (check.getUTCFullYear() !== yil || check.getUTCMonth() !== ay - 1 || check.getUTCDate() !== gun) {
      return null;
    }

    const mm = ay.toString().padStart(2, '0');
    const dd = gun.toString().padStart(2, '0');
    return `${yil}-${mm}-${dd}`;
  }

  // Ek-alanı tabloda göster: tür "date" ise ISO (YYYY-MM-DD) değeri
  // vade tarihi gibi GG/AA/YYYY olarak gösterilir. Diğer türlerde ham değer.
  // Not: backende GÖNDERİLEN değer ISO olarak kalır; bu sadece gösterimdir.
  ekAlanGoster(ek: any): string {
    if (!ek) return '';
    const deger = ek.deger;
    if (deger === '' || deger === null || deger === undefined) return '';
    if (ek.tur === 'date') {
      const ddmmyyyy = this.isoToDdmmyyyy(String(deger));
      if (ddmmyyyy) return ddmmyyyy;
    }
    return String(deger);
  }

  // ISO (YYYY-MM-DD) -> GG/AA/YYYY. Eşleşmezse null.
  isoToDdmmyyyy(iso: string): string | null {
    const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m ? `${m[3]}/${m[2]}/${m[1]}` : null;
  }

  // Standart tarih alanları (vade/takip/faiz) için: number veya çeşitli string
  // formatlarını backendin beklediği GG/AA/YYYY (saatsiz) formatına çevirir.
  // Çözülemezse ham değeri (trim) geri döner; eksik-alan kontrolü yakalasın.
  normalizeStandartTarih(value: any, date1904 = false): string {
    // Bu metot yalnız bilinen standart tarih sütunlarında çağrılır; sayı burada güvenle
    // Excel seri tarihi olarak yorumlanabilir. Diğer sayısal sütunlar bu yola girmez.
    const iso = this.parseEkAlanTarih(value, typeof value === 'number', date1904);
    if (iso !== null) {
      const ddmmyyyy = this.isoToDdmmyyyy(iso);
      if (ddmmyyyy) return ddmmyyyy;
    }
    return value == null ? '' : String(value).trim();
  }

  downloadExcel() {
    this.downloading = true;
    this.$helper
        .download(
            "OrnekExcel.xls",
            "/api/v1/excel-aktar-ornek-file"
        )
        .finally(() => {
          this.downloading = false;
        });
  }
  mounted(){
    window.addEventListener('dragover', this.handleDragEnter);
    this.headers.forEach((item:any) => {
      if (item.text!=='KALDIR' && item.text!=='DÜZENLE' && item.text!=='DURUM'){
        this.excelHeaders[item.text] = item.value;
      }
    });
    this.referanslariYukle();
  }
  handleDragOver() {
    this.isDragOver = true;
  }
  handleDragLeave() {
    this.isDragOver = false;
  }
  beforeDestroy() {
    window.removeEventListener('dragover', this.handleDragEnter);
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.sayacIntervalId) clearInterval(this.sayacIntervalId);
  }

  handleDragEnter(event: any) {
    event.preventDefault();
    this.isDragOver = true;
  }

  handleFileDrop(event: any) {
    this.isDragOver = false
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length) {
      const file = droppedFiles[0];
      if (file.name.split('.').pop().toLowerCase() == 'xlsx') {
        this.excelFile = file;
      } else {
        // Geçersiz dosya türü için hata yönetimi (isteğe bağlı)
        this.$toast.warning('Lütfen bir XML dosyası yükleyin.');
      }
    }
  }
  /*
    kontrolHeaders = [
      {text: "TEKİL ALAN", value: "tekil_alan"},
      {text: "TAKİP TİPİ", value: "takip_tipi"},
      {text: "TAKİP ALT TİPİ", value: "takip_alt_tipi"},
      {text: "TAKİP YOLU", value: "takip_yolu"},
      {text: "DURUM", value: "status"},
      {text: "KALDIR", value: "remove"},
    ];
  */

  headers:any = [
    {text: "KALDIR", value: "remove"},
    {text: "DÜZENLE", value: "duzenle"},
    {text: "DURUM", value: "status"},
    {text: "TEKİL ALAN", value: "tekil_alan"},
    {text: "TAKİP TİPİ", value: "takip_tipi"},
    {text: "TAKİP YOLU", value: "takip_yolu"},
    {text: "TAKİP TARİHİ", value: "takip_tarihi"},
    {text: "TAKİP MAHİYETİ", value: "takip_mahiyeti"},
    {text: "İCRA DAİRESİ", value: "icra_dairesi"},
    {text: "ESAS NO", value: "esas_no"},
    {text: "TÜKETİCİ KODU", value: "tuketici_kodu"},
    {text: "ALACAKLI KURUM/KİŞİ", value: "alacakli_kurum_mu"},
    {text: "ALACAKLI AD SOYAD", value: "alacakli_ad"},
    {text: "ALACAKLI KURUM İSİM", value: "alacakli_isim"},
    {text: "ALACAKLI VERGİ/TC NO", value: "alacakli_tc_vergi"},
    {text: "BORÇLU AD SOYAD", value: "borclu_ad"},
    {text: "BORÇLU KURUM İSİM", value: "borclu_isim"},
    {text: "BORÇLU VERGİ/TC NO", value: "borclu_tc_vergi"},
    {text: "BORÇLU CİNSİYET", value: "borclu_cinsiyet"},
    {text: "BORÇLU ADRESİ", value: "borclu_adres_bilgisi"},
    {text: "BORÇLU İL", value: "borclu_il"},
    {text: "BORÇLU İLÇE", value: "borclu_ilce"},
    {text: "BORÇLU TÜRÜ ŞAHIS ŞİRKET", value: "borclu_kurum_mu"},
    {text: "BORÇLU CEP TELEFON", value: "cepTelefon"},
    {text: "BELGE TUTARI", value: "tutar"},
    {text: "VADE TARİHİ", value: "vade_tarihi"},
    {text: "FAİZ BAŞLANGIÇ TARİHİ", value: "faiz_baslangic_tarihi"},
    {text: "ALACAK AÇIKLAMASI", value: "alacak_aciklama"},
    {text: "TAKİP ÖNCESİ FAİZ TÜRÜ", value: "takip_oncesi_faiz_turu"},
    {text: "TAKİP SONRASI FAİZ TÜRÜ", value: "takip_sonrasi_faiz_turu"},
    {text: "ELLE FAİZ Mİ", value: "elle_faiz_mi"},
    {text: "ORAN/TUTAR", value: "elle_faiz_tutar_mi"},
    {text: "AYLIK/YILLIK", value: "yillik_mi"},
    {text: "İŞLEYEN FAİZ", value: "elle_faiz_tutari"},
    {text: "ORAN", value: "elle_faiz_oran"},

  ];

  // Tablo üstü hata özeti: hangi satırda hangi alan(lar) hatalı.
  get hataOzeti(): {satir: number, alanlar: string[]}[] {
    const ozet: {satir: number, alanlar: string[]}[] = [];
    Object.keys(this.eksikAlanlar).forEach((idx: string) => {
      const hatalar = this.eksikAlanlar[idx];
      if (hatalar && Array.isArray(hatalar) && hatalar.length > 0) {
        ozet.push({
          satir: Number(idx) + 1,
          alanlar: hatalar.map((h: any) => h.baslik),
        });
      }
    });
    return ozet.sort((a, b) => a.satir - b.satir);
  }

  // --- Satır düzenleme modalı (sağ tık) ---

  // v-dialog v-model'i: index varsa açık.
  get satirModalAcik(): boolean {
    return this.satirModalIndex !== null;
  }
  set satirModalAcik(acik: boolean) {
    if (!acik) this.satirModalIndex = null;
  }

  // Modalda gösterilecek düzenlenebilir alanlar (kaldır/düzenle/durum hariç tüm sütunlar).
  get modalAlanlar(): any[] {
    return this.headers.filter((h: any) => h.value !== 'remove' && h.value !== 'duzenle' && h.value !== 'status');
  }

  satirDuzenleAc(index: number): void {
    this.satirModalIndex = index;
  }

  satirDuzenleKapat(): void {
    this.satirModalIndex = null;
  }

  // --- Inline hücre düzenleme (Faz 4) ---

  duzenlemeAktifMi(index: number, alan: string): boolean {
    return !!this.duzenlenen && this.duzenlenen.index === index && this.duzenlenen.alan === alan;
  }

  duzenlemeBaslat(index: number, alan: string): void {
    this.duzenlenen = {index, alan};
  }

  duzenlemeKapat(): void {
    this.duzenlenen = null;
  }

  // Hücre giriş tipi (referans dışı alanlar için): enum → açılır menü, sayı → number,
  // tarih → takvim, metin → metin kutusu. Referans alanları template'te ReferansSelect ile
  // ayrıca ele alınır (referansAlanMi).
  hucreInputTipi(alan: string): string {
    const kural = (SUTUN_KURALLARI as any)[alan];
    return kural ? kural.tip : 'metin';
  }

  hucreEnumSecenekleri(alan: string): string[] {
    const kural = (SUTUN_KURALLARI as any)[alan];
    return kural && kural.enumDegerler ? kural.enumDegerler : [];
  }

  // --- Referans alanları (icraproweb listeleri) ---

  // Referans alanı: DB-düz (referansKaynaklari), statik (referansStatik) veya il'e bağımlı ilçe.
  referansAlanMi(alan: string): boolean {
    return alan === 'borclu_ilce'
      || Object.prototype.hasOwnProperty.call(this.referansKaynaklari, alan)
      || Object.prototype.hasOwnProperty.call(this.referansStatik, alan);
  }

  // Bu alan için yüklü seçenekler ({text, value}) — düz (il'e bağımlı olmayan) alanlar için.
  referansSecenek(alan: string): {text: string, value: any}[] {
    return this.referansSecenekleri[alan] || [];
  }

  // Template'in kullandığı birleşik seçenek çözücü: ilçe satırın il'ine göre, statik sabit,
  // diğerleri düz DB listesi.
  referansItemleri(alan: string, item: any): {text: string, value: any}[] {
    if (alan === 'borclu_ilce') return this.ilceSecenek(item);
    if (this.referansStatik[alan]) return this.referansStatik[alan];
    return this.referansSecenek(alan);
  }

  // Bu referans alanı serbest metne izin veriyor mu (ör. icra_dairesi → ozel fallback).
  referansSerbestMi(alan: string): boolean {
    const k = this.referansKaynaklari[alan];
    return !!(k && k.serbestMetin);
  }

  // Alan bu satır bağlamında geçersiz mi → düzenlenemez "—" gösterilir (boş hücreye yazma engellenir).
  // Kişi/kurum türüne göre geçersiz taraf kimlik alanları; validasyondaki (alanZorunluMu) kurallarla aynı.
  alanGizliMi(alan: string, item: any): boolean {
    if (!item) return false;
    const borcluKurum = item.borclu_kurum_mu;      // 'KURUM' | 'KİŞİ'
    const alacakliKurum = item.alacakli_kurum_mu;
    // Borçlu KURUM → kişi alanları (ad-soyad, cinsiyet) geçersiz; KİŞİ → kurum ismi geçersiz.
    if (borcluKurum === 'KURUM' && (alan === 'borclu_ad' || alan === 'borclu_cinsiyet')) return true;
    if (borcluKurum === 'KİŞİ' && alan === 'borclu_isim') return true;
    // Alacaklı için aynı kural.
    if (alacakliKurum === 'KURUM' && alan === 'alacakli_ad') return true;
    if (alacakliKurum === 'KİŞİ' && alan === 'alacakli_isim') return true;
    return false;
  }

  // Excel'deki faiz SIRA numarasını isme çevirir (bkz. faizSirasiniIsmeCevir).
  faizSirasiniIsmeCevir(deger: any): string {
    return faizSirasiniIsmeCevir(deger);
  }

  // Payload'a giden faiz türü değeri: boşsa null, doluysa isim (backend isimle çözer).
  faizDegeri(deger: any): string | null {
    if (deger === null || deger === undefined) return null;
    const s = String(deger).trim();
    return (s === '' || s === '0') ? null : s;
  }

  // Takip yolu "Diğer" mi (o zaman serbest metin/manuel_takip_yolu istenir)? Değer parse'ta kanonikleştirilir.
  takipYoluDigerMi(item: any): boolean {
    return !!item && item.takip_yolu === 'DİĞER';
  }

  // Alan sabitlenmiş mi (ör. takip tipi yalnız İlamsız) → düzenlenemez, sabit etiket gösterilir.
  alanKilitliMi(alan: string): boolean {
    return Object.prototype.hasOwnProperty.call(this.kilitliAlanEtiketleri, alan);
  }

  // Kilitli alanları kanonik değerine sabitler. Hücre düzenlenemediği için, Excel'den boş ya da
  // hatalı (ör. metin) gelen değer doğrulamada hata verip kullanıcıyı çıkmaza sokuyordu.
  kilitliAlanlariUygula(item: any): void {
    if (!item) return;
    Object.keys(this.kilitliAlanDegerleri).forEach((alan: string) => {
      this.$set(item, alan, this.kilitliAlanDegerleri[alan]);
    });
  }
  kilitliEtiket(alan: string): string {
    return this.kilitliAlanEtiketleri[alan] || '';
  }

  // Türkçe i ailesi duyarsız normalize (il isim → sehir_id eşlemesi için).
  private ilNormalize(s: string): string {
    return String(s || '')
      .replace(/İ/g, 'i').replace(/I/g, 'i').replace(/ı/g, 'i')
      .toLocaleLowerCase('tr-TR')
      .trim();
  }

  // Satırın il'inin sehir_id'sini bulup ilçe listesini (cache'li) yükler; dropdown açılınca çağrılır.
  ilceYukle(item: any): Promise<void> {
    const ilAd = item ? String(item.borclu_il || '').trim() : '';
    if (ilAd === '') return Promise.resolve();
    const sehirId = this.sehirAdIdMap[this.ilNormalize(ilAd)];
    if (sehirId === undefined || sehirId === null) return Promise.resolve();
    return this.ilceIdYukle(sehirId);
  }

  // sehir_id'ye göre ilçe listesini (cache'li, tek uçuş) yükler; await edilebilir.
  ilceIdYukle(sehirId: any): Promise<void> {
    const key = String(sehirId);
    if (this.ilceCache[key]) return Promise.resolve();
    if (this.ilceYuklePromise[key]) return this.ilceYuklePromise[key];
    const p = this.$helper.requestWithCache('/api/v1/sehir/' + sehirId + '/ilce').then((response: any) => {
      const liste = this.yanitListesi(response);
      const secenekler = liste
        .map((x: any) => ({
          text: x && x.isim != null ? String(x.isim).trim() : '',
          value: x && x.isim != null ? String(x.isim).trim() : '',
        }))
        .filter((s: {text: string}) => s.text !== '');
      this.$set(this.ilceCache, key, secenekler);
    }).catch(() => {
      this.$set(this.ilceCache, key, []);
    });
    this.$set(this.ilceYuklePromise, key, p);
    return p;
  }

  // Satırın il'ine ait yüklü ilçe listesi (yoksa boş; dropdown açılınca ilceYukle doldurur).
  ilceSecenek(item: any): {text: string, value: any}[] {
    const ilAd = item ? String(item.borclu_il || '').trim() : '';
    if (ilAd === '') return [];
    const sehirId = this.sehirAdIdMap[this.ilNormalize(ilAd)];
    if (sehirId === undefined || sehirId === null) return [];
    return this.ilceCache[String(sehirId)] || [];
  }

  // ReferansSelect açıldığında: ilçe için satırın il'ine göre listeyi tembel yükle.
  referansAcildi(alan: string, item: any): void {
    if (alan === 'borclu_ilce') this.ilceYukle(item);
  }

  // İl/ilçe ham Excel değerlerini icraproweb'deki kanonik isme çevirir (Türkçe-duyarlı eşleşme).
  // Backend Sehir/Ilce::isim'i birebir (Türkçe-duyarsız LOWER ile) eşlediği için "KADIKÖY" gibi
  // değerler düşüyordu; burada "Kadıköy"e standardize edilir → backend tutar. Salt değer düzeltme.
  async ilIlceNormalizeEt(): Promise<void> {
    const ilList = this.referansSecenek('borclu_il');
    if (!ilList.length) return; // il listesi henüz yüklenmediyse dokunma

    // 1) İl → kanonik isim
    this.items.forEach((item: any) => {
      const ham = item && item.borclu_il != null ? String(item.borclu_il).trim() : '';
      if (ham === '') return;
      const bul = ilList.find((s) => this.ilNormalize(String(s.value)) === this.ilNormalize(ham));
      if (bul && bul.value !== item.borclu_il) this.$set(item, 'borclu_il', bul.value);
    });

    // 2) İlgili şehirlerin ilçe listelerini yükle (await)
    const sehirIdSet = new Set<string>();
    this.items.forEach((item: any) => {
      const il = item && item.borclu_il ? String(item.borclu_il).trim() : '';
      const ilce = item && item.borclu_ilce ? String(item.borclu_ilce).trim() : '';
      if (il && ilce) {
        const sid = this.sehirAdIdMap[this.ilNormalize(il)];
        if (sid != null) sehirIdSet.add(String(sid));
      }
    });
    await Promise.all(Array.from(sehirIdSet).map((sid) => this.ilceIdYukle(sid)));

    // 3) İlçe → kanonik isim
    this.items.forEach((item: any) => {
      const il = item && item.borclu_il ? String(item.borclu_il).trim() : '';
      const ilce = item && item.borclu_ilce ? String(item.borclu_ilce).trim() : '';
      if (!il || !ilce) return;
      const sid = this.sehirAdIdMap[this.ilNormalize(il)];
      if (sid == null) return;
      const liste = this.ilceCache[String(sid)] || [];
      const bul = liste.find((s) => this.ilNormalize(String(s.value)) === this.ilNormalize(ilce));
      if (bul && bul.value !== item.borclu_ilce) this.$set(item, 'borclu_ilce', bul.value);
    });
  }

  // Hücre görüntüsü: id-değerli referans alanında saklanan id'yi isme çevirip gösterir
  // (kullanıcı ham sayı yerine anlamlı ismi görür). Diğer alanlarda değerin kendisini döndürür.
  hucreGoster(alan: string, deger: any): string {
    if (deger === '' || deger === null || deger === undefined) return '—';
    // Para alanı (belge tutarı) → ekranda ,00 formatı (salt görsel; saklanan/gönderilen değer ham kalır).
    if (this.paraAlanMi(alan)) {
      const f = this.paraFormatla(deger);
      if (f !== null) return f;
    }
    if (this.referansAlanMi(alan) && this.referansKaynaklari[alan] && !this.referansKaynaklari[alan].serbestMetin) {
      const sec = this.referansSecenek(alan).find((s) => String(s.value) === String(deger));
      if (sec) return sec.text;
    }
    return String(deger);
  }

  // Para alanı mı (ekranda ,00 formatı) — belge tutarı.
  paraAlanMi(alan: string): boolean {
    return alan === 'tutar';
  }
  // Sayıyı TR para formatına çevirir ("5.000,00"); çözülemezse null (ham gösterilir).
  paraFormatla(deger: any): string | null {
    const n = parFloat(deger);
    if (n === null) return null;
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // API yanıtından liste çıkarır: düz dizi ({data:[...]}) veya iç içe ({data:{data:[...]}}) — ikisini de karşılar.
  private yanitListesi(response: any): any[] {
    const raw = response && response.data;
    if (Array.isArray(raw)) return raw;
    if (raw && Array.isArray(raw.data)) return raw.data;
    return [];
  }

  // Gösterim metni: "isim" veya kodAlan varsa "isim (kod)" (ör. "İstanbul (34)"). Salt-görsel;
  // gönderilen değer (degerAlan) bundan etkilenmez, arama koda da bakar.
  private referansMetni(x: any, kaynak: {metinAlan: string, kodAlan?: string}): string {
    const ana = x && x[kaynak.metinAlan] != null ? String(x[kaynak.metinAlan]).trim() : '';
    if (ana === '') return '';
    if (kaynak.kodAlan && x[kaynak.kodAlan] != null && String(x[kaynak.kodAlan]).trim() !== '') {
      return ana + ' (' + String(x[kaynak.kodAlan]).trim() + ')';
    }
    return ana;
  }

  // Tanımlı tüm referans listelerini backend'den (cache'li) çeker; alan → {text, value} olarak saklar.
  referanslariYukle(): void {
    Object.keys(this.referansKaynaklari).forEach((alan: string) => {
      const kaynak = this.referansKaynaklari[alan];
      this.$helper.requestWithCache(kaynak.endpoint).then((response: any) => {
        const liste = this.yanitListesi(response);
        const secenekler = liste
          .map((x: any) => ({
            text: this.referansMetni(x, kaynak),
            value: x ? x[kaynak.degerAlan] : null,
          }))
          .filter((s: {text: string}) => s.text !== '');
        this.$set(this.referansSecenekleri, alan, secenekler);
        // İl yüklenince isim → sehir_id haritasını kur (ilçe listesini çekmek için gerekli).
        if (alan === 'borclu_il') {
          const harita: Record<string, any> = {};
          liste.forEach((x: any) => {
            if (x && x.isim != null && x.id != null) harita[this.ilNormalize(String(x.isim))] = x.id;
          });
          this.sehirAdIdMap = harita;
        }
      }).catch(() => {
        this.$set(this.referansSecenekleri, alan, []);
      });
    });
  }

  // Tarih hücresi için HTML5 <input type="date"> ISO (YYYY-MM-DD) değeri ister.
  // Hücredeki GG/AA/YYYY (veya çözülebilir) değeri ISO'ya çevirir; çözülemezse boş.
  tarihInputDegeri(deger: any): string {
    return parseTarih(deger) || '';
  }

  // Takvimden seçilen ISO (YYYY-MM-DD) değeri, hücrenin beklediği GG/AA/YYYY'ye
  // çevrilip yazılır ve satır yeniden doğrulanır.
  tarihSecildi(index: number, alan: string, isoDeger: string): void {
    const ddmmyyyy = this.isoToDdmmyyyy(isoDeger) || isoDeger;
    this.hucreGuncelle(index, alan, ddmmyyyy);
  }

  // Alacak kalemi alanları: her satır kendi alacak kalemini taşır (payload satır başına bir kalem
  // gönderiyor). Bunları kardeş satırlara YAYMAK borç tutarını bozar → satır-bazlı kalmalılar.
  static readonly ALACAK_KALEMI_ALANLARI = [
    'tutar', 'vade_tarihi', 'faiz_baslangic_tarihi', 'alacak_aciklama',
    'takip_oncesi_faiz_turu', 'takip_sonrasi_faiz_turu',
    'elle_faiz_mi', 'elle_faiz_tutar_mi', 'elle_faiz_tutari', 'yillik_mi', 'elle_faiz_oran',
  ];

  // Takip-seviyesi alan mı (aynı tekil alan = 1 takip → tüm kardeş satırlarda ortak)?
  // Borçlu alanları (borclu_*, cepTelefon) ve alacak kalemi alanları satır-bazlıdır;
  // tekil_alan anahtardır. Gerisi (takip başlığı + alacaklı) takip-seviyesidir ve
  // düzenlenince aynı tekil_alan'daki kardeş satırlara yayılır.
  takipSeviyesiAlanMi(alan: string): boolean {
    if (alan === 'tekil_alan' || alan === 'cepTelefon') return false;
    if (alan.indexOf('borclu_') === 0) return false;
    if (TopluExcelTakip.ALACAK_KALEMI_ALANLARI.indexOf(alan) !== -1) return false;
    return true;
  }

  // Bir satırı enum-normalize edip yeniden doğrular (eksikAlanlar'ı günceller).
  private satiriYenidenDogrula(i: number): void {
    if (!this.items[i]) return;
    enumAlanlariNormalizeEt(this.items[i]);
    const hatalar = satiriDogrula(this.items[i]);
    if (hatalar.length > 0) this.$set(this.eksikAlanlar, i, hatalar);
    else this.$delete(this.eksikAlanlar, i);
  }

  // Değeri yaz → (takip-seviyesiyse) aynı tekil alandaki kardeş satırlara yay → yeniden doğrula.
  hucreGuncelle(index: number, alan: string, deger: any): void {
    this.$set(this.items[index], alan, deger);
    // İl değişince eski ilçe artık geçersiz → sıfırla (yanlış il/ilçe eşleşmesini önler).
    if (alan === 'borclu_il') {
      this.$set(this.items[index], 'borclu_ilce', '');
    }
    // Takip-seviyesi alan → aynı tekil alandaki tüm kardeş satırlara uygula (1 tekil alan = 1 takip).
    if (this.takipSeviyesiAlanMi(alan)) {
      const tekil = this.items[index].tekil_alan;
      this.items.forEach((it: any, i: number) => {
        if (i !== index && it && it.tekil_alan === tekil) {
          this.$set(it, alan, deger);
          this.satiriYenidenDogrula(i);
        }
      });
    }
    this.satiriYenidenDogrula(index);
  }

  // --- Toplu değiştir (tüm satırlara uygula) ---
  // Bulk-değiştirilebilir alanlar: takip-seviyesi alanlar + borçlu adres alanları
  // (borçlu kimlik alanları ve kilitli takip tipi hariç — onlar satır/kayıt bazlı kalır).
  get topluAlanlar(): {text: string, value: string}[] {
    // Borçlu adres alanları + alacak kalemi alanları satır-bazlı olsa da toplu değiştirmek
    // kullanıcının BİLİNÇLİ eylemi olduğu için listede kalır. borclu_ilce hariç: liste ilk satırın
    // iline göre yüklendiğinden karışık illi dosyada uyumsuz ilçe yazılmasına yol açıyordu.
    const elleEklenen = ['borclu_adres_bilgisi', 'borclu_il'].concat(TopluExcelTakip.ALACAK_KALEMI_ALANLARI);
    return this.headers
      .filter((h: any) => !['remove', 'duzenle', 'status', 'tekil_alan'].includes(h.value))
      .filter((h: any) => !this.alanKilitliMi(h.value))
      .filter((h: any) => this.takipSeviyesiAlanMi(h.value) || elleEklenen.indexOf(h.value) !== -1)
      .map((h: any) => ({ text: h.text, value: h.value }));
  }

  // Toplu değiştir için seçilen değer boş mu (boş değerle "Tümüne Uygula" kolonu silerdi).
  // Toplu degistirmede takip yolu "DIGER" mi secildi (o zaman aciklama da istenir)?
  get topluDigerMi(): boolean {
    return this.topluAlan === 'takip_yolu'
      && String(this.topluDeger === null || this.topluDeger === undefined ? '' : this.topluDeger).trim() === 'DİĞER';
  }

  // "Tumune Uygula" kapali mi: deger bos, ya da DIGER secilip aciklama girilmemis.
  get topluUygulaKapali(): boolean {
    if (this.topluDegerBos) return true;
    if (this.topluDigerMi && String(this.topluManuelYolu || '').trim() === '') return true;
    return false;
  }

  get topluDegerBos(): boolean {
    const d = this.topluDeger;
    return d === null || d === undefined || String(d).trim() === '';
  }

  // Seçili alanı seçili değerle tüm satırlara uygular (hucreGuncelle → doğrulama + tekil-alan senkronu).
  topluUygula(): void {
    const alan = this.topluAlan;
    if (!alan || this.topluUygulaKapali) return;
    let deger = this.topluDeger;
    if (this.hucreInputTipi(alan) === 'tarih' && deger) {
      deger = this.isoToDdmmyyyy(deger) || deger;
    }
    const digerAciklamasi = this.topluDigerMi ? String(this.topluManuelYolu).trim() : null;
    this.items.forEach((_: any, i: number) => {
      this.hucreGuncelle(i, alan, deger);
      // Takip yolu "DIGER" iken aciklama zorunlu; satir bazli duzenlemedeki davranisin aynisi
      // toplu islemde de gecerli olmali, yoksa her satir hatali kalir ve toplu duzeltme ise yaramaz.
      if (digerAciklamasi !== null) {
        this.hucreGuncelle(i, 'manuel_takip_yolu', digerAciklamasi);
      }
    });
    this.$toast.success('Seçili alan tüm satırlara uygulandı.');
  }

  hucreHatasi(index: number, alan: string): any {
    const hatalar = this.eksikAlanlar[index];
    if (!hatalar || !Array.isArray(hatalar)) return null;
    return hatalar.find((h: any) => h.alan === alan) || null;
  }

  hucreHataMesaji(index: number, alan: string): string {
    const h = this.hucreHatasi(index, alan);
    return h ? h.mesaj : '';
  }

  removeItem(itemToRemove: any) {
    const tekilAlan = itemToRemove.tekil_alan;
    this.items = this.items.filter((item: any) => item.tekil_alan !== tekilAlan);
    // eksikAlanlar satır INDEX'i ile anahtarlanır; satır silinince indeksler kayar. Eski kod
    // filtrelenmiş listede silinen satırı aradığı için (indexOf hep -1) hiçbir şey yapmıyordu →
    // yanlış satır kırmızı görünüyor, gerçekten hatalı satır kapıdan geçebiliyordu.
    // Kalan satırlara göre baştan kur ve tek seferde ata (Vue 2 reaktivitesi için).
    this.eksikAlanlariYenidenKur();
  }

  // Tüm satırları yeniden doğrulayıp eksikAlanlar'ı sıfırdan kurar (index kaymalarına karşı).
  eksikAlanlariYenidenKur(): void {
    const yeni: any = {};
    this.items.forEach((item: any, index: number) => {
      const hatalar = satiriDogrula(item);
      if (hatalar.length > 0) yeni[index] = hatalar;
    });
    this.eksikAlanlar = yeni;
  }

  listeleClick() {
    if (this.excelFile) {
      this.listTable = true;
      this.parseExcelData()
      this.onFocusTable()
      this.e1 = 2

    }else{
      this.$toast.error('Lütfen Excel Dosyası Ekleyiniz')
    }
  }

  onFocusTable(){
    this.$nextTick(() => {
      if (this.$refs.listTableRef) {
        this.$vuetify.goTo(this.$refs.listTableRef.$el, {
          duration: 800,
          offset: 100, // Tablonun altına 100px boşluk bırak
          easing: 'easeInOutCubic'
        });
      }
    });
  }

  splitBorcluAdSoyad(adSoyad: string): {ad: string, soyad: string} {
    if (!adSoyad) return {ad: '', soyad: ''};

    const trimmed = adSoyad.trim();
    const lastSpaceIndex = trimmed.lastIndexOf(' ');

    if (lastSpaceIndex === -1) {
      return {ad: trimmed, soyad: ''};
    }

    return {
      ad: trimmed.substring(0, lastSpaceIndex),
      soyad: trimmed.substring(lastSpaceIndex + 1)
    };
  }
  splitAlacakliAdSoyad(adSoyad: string): {alacakli_ad: string, alacakli_soyad: string} {
    if (!adSoyad) return {alacakli_ad: '', alacakli_soyad: ''};

    const trimmed = adSoyad.trim();
    const lastSpaceIndex = trimmed.lastIndexOf(' ');

    if (lastSpaceIndex === -1) {
      return {alacakli_ad: trimmed, alacakli_soyad: ''};
    }

    return {
      alacakli_ad: trimmed.substring(0, lastSpaceIndex),
      alacakli_soyad: trimmed.substring(lastSpaceIndex + 1)
    };
  }


  async topluTakipAc() {
    // Güvenlik kontrolü: Eksik alan varsa işleme izin verme
    const hasInvalidRows = Object.values(this.eksikAlanlar).some(
      (eksikler: any) => eksikler !== null && Array.isArray(eksikler) && eksikler.length > 0
    );

    if (hasInvalidRows) {
      this.$toast.error(
        "Bazı satırlarda eksik bilgiler var!\n\nLütfen kırmızı X ikonlu satırları düzeltin veya KALDIR butonuyla silin.",
        { duration: 6000 }
      );
      return;
    }

    // Items boş kontrolü
    if (!this.items || this.items.length === 0) {
      this.$toast.warning("Excel'de işlenecek kayıt bulunamadı.");
      return;
    }

    // Gönderim öncesi kilitli alanları (takip tipi) ve il/ilçeyi kanonik hâle getir — garanti.
    this.items.forEach((it: any) => this.kilitliAlanlariUygula(it));
    await this.ilIlceNormalizeEt();

    // Başlama bekleme sayacı: cron işlemeyi başlatana kadar geçen süreyi kullanıcıya göster.
    this.gecenSaniye = 0;
    this.arkaPlandaTakip = false;
    if (this.sayacIntervalId) clearInterval(this.sayacIntervalId);
    this.sayacIntervalId = window.setInterval(() => { this.gecenSaniye++; }, 1000);

    this.durumTable = true;

    const groupedItems: { [key: string]: any[] } = {};

    this.items.forEach((item: any) => {
      const tekilAlan = item.tekil_alan;
      if (!groupedItems[tekilAlan]) {
        groupedItems[tekilAlan] = [];
      }
      groupedItems[tekilAlan].push(item);
    });

    let firstCreatedAt: any = null;
    let processedCount = 0;
    const tekilAlanKeys = Object.keys(groupedItems);
    const totalGroups = tekilAlanKeys.length;

    // Group tekilAlan keys into batches of 25
    const batchSize = 25;
    const batches: string[][] = [];

    for (let i = 0; i < tekilAlanKeys.length; i += batchSize) {
      batches.push(tekilAlanKeys.slice(i, i + batchSize));
    }

    // Process each batch
    batches.forEach((batch, batchIndex) => {
      const batchRequests = batch.map(tekilAlan => {
        const itemsForTekilAlan = groupedItems[tekilAlan];
        const topluKartEkleme = new TopluKartEkleme();
        topluKartEkleme.dosyaBilgileri = new DosyaBilgileri();
        // Aynı tekil_alan = 1 takip; çok borçlulu dosyalarda takip/alacak bilgisi HER borçlu
        // satırında tekrarlanır. Backend gelen her kalem için ayrı Alacak+AlacakKalemi yarattığı
        // (mükerrer kontrolü yok) için birebir aynı kalem N kez gönderilirse takip borcu N katına
        // çıkıyordu. Birebir kopyaları eliyoruz; gerçekten farklı kalemler korunur.
        const gorulenKalemler: string[] = [];

        itemsForTekilAlan.forEach((item) => {
          const borcluBilgisi = new BorcluBilgileri();
          const alacakliBilgisi = new AlacakliBilgileri();
          const alacakKalemleriBilgisi = new AlacakKalemiBilgileri();

          const {ad, soyad} = this.splitBorcluAdSoyad(item.borclu_ad);
          borcluBilgisi.ad = ad;
          borcluBilgisi.soyad = soyad;
          borcluBilgisi.isim = item.borclu_isim;
          borcluBilgisi.cinsiyet = item.borclu_cinsiyet;
          borcluBilgisi.borclu_tc_vergi = item.borclu_tc_vergi;
          borcluBilgisi.adres_bilgisi = item.borclu_adres_bilgisi;
          borcluBilgisi.adres_turu = 'YURT İÇİ İKAMET';
          borcluBilgisi.il = item.borclu_il;
          borcluBilgisi.ilce = item.borclu_ilce;
          borcluBilgisi.kurum = item.borclu_kurum_mu;
          borcluBilgisi.cepTelefon = item.cepTelefon;

          topluKartEkleme.borcluBilgileri.push(borcluBilgisi);

          // Dosya Bilgileri sadece bir kez atanmalı
          if (topluKartEkleme.dosyaBilgileri.tekil_alan === undefined) {
            topluKartEkleme.dosyaBilgileri.takip_tipi = item.takip_tipi;
            topluKartEkleme.dosyaBilgileri.takip_alt_tipi = 'GENEL';
            topluKartEkleme.dosyaBilgileri.takip_yolu = item.takip_yolu;
            topluKartEkleme.dosyaBilgileri.manuel_takip_yolu = item.manuel_takip_yolu || '';
            topluKartEkleme.dosyaBilgileri.takip_tarihi = item.takip_tarihi;
            topluKartEkleme.dosyaBilgileri.tekil_alan = item.tekil_alan;
            topluKartEkleme.dosyaBilgileri.takip_mahiyeti = item.takip_mahiyeti;
            topluKartEkleme.dosyaBilgileri.icra_dairesi = item.icra_dairesi;
            topluKartEkleme.dosyaBilgileri.esas_no = item.esas_no;
            topluKartEkleme.dosyaBilgileri.tuketici_kodu = item.tuketici_kodu;
            // Ek-alanlar: sadece değeri dolu olanları gönder (dinamik ek-alan türleri)
            topluKartEkleme.dosyaBilgileri.ek_alanlar = (item._ekAlanlar || []).filter(
              (ek: any) => ek && ek.isim && ek.deger !== '' && ek.deger != null
            );
          }

          //Alacaklı Bilgileri
          const {alacakli_ad, alacakli_soyad} = this.splitAlacakliAdSoyad(item.alacakli_ad);
          alacakliBilgisi.alacakli_isim = item.alacakli_isim;
          alacakliBilgisi.alacakli_tc_vergi = item.alacakli_tc_vergi;
          alacakliBilgisi.alacakli_ad = alacakli_ad;
          alacakliBilgisi.alacakli_soyad = alacakli_soyad;
          alacakliBilgisi.alacakli_kurum_mu = item.alacakli_kurum_mu;
          topluKartEkleme.alacakliBilgileri.push(alacakliBilgisi);

          //Alacak Kalemi Bilgileri
          alacakKalemleriBilgisi.belge_turu = 'DİĞER';
          alacakKalemleriBilgisi.tutar = item.tutar;
          alacakKalemleriBilgisi.vade_tarih = item.vade_tarihi;
          alacakKalemleriBilgisi.faiz_baslangic_tarih = item.faiz_baslangic_tarihi;
          alacakKalemleriBilgisi.alacak_aciklamasi = item.alacak_aciklama;
          // Faiz türü artık parse'ta isme çevriliyor ve dropdown tenant listesinden isim yazıyor;
          // enum üzerinden ikinci bir çeviri YAPILMAZ (tenant'ta olmayan isim üretiyordu).
          alacakKalemleriBilgisi.takip_oncesi_faiz_turu = this.faizDegeri(item.takip_oncesi_faiz_turu);
          alacakKalemleriBilgisi.takip_sonrasi_faiz_turu = this.faizDegeri(item.takip_sonrasi_faiz_turu);
          alacakKalemleriBilgisi.elle_faiz_mi = item.elle_faiz_mi === 'EVET' ? true : false;
          alacakKalemleriBilgisi.elle_faiz_tutar_mi = item.elle_faiz_tutar_mi === 'TUTAR' ? true : false;
          alacakKalemleriBilgisi.elle_faiz_tutari = item.elle_faiz_tutari;
          alacakKalemleriBilgisi.yillik_mi = item.yillik_mi=='YILLIK'?true:false;
          alacakKalemleriBilgisi.elle_faiz_oran = item.elle_faiz_oran;

          // Birebir aynı kalemi ikinci kez gönderme (bkz. gorulenKalemler açıklaması).
          const kalemImza = JSON.stringify([
            alacakKalemleriBilgisi.tutar, alacakKalemleriBilgisi.vade_tarih,
            alacakKalemleriBilgisi.faiz_baslangic_tarih, alacakKalemleriBilgisi.alacak_aciklamasi,
            alacakKalemleriBilgisi.takip_oncesi_faiz_turu, alacakKalemleriBilgisi.takip_sonrasi_faiz_turu,
            alacakKalemleriBilgisi.elle_faiz_mi, alacakKalemleriBilgisi.elle_faiz_tutar_mi,
            alacakKalemleriBilgisi.elle_faiz_tutari, alacakKalemleriBilgisi.yillik_mi,
            alacakKalemleriBilgisi.elle_faiz_oran,
          ]);
          if (gorulenKalemler.indexOf(kalemImza) === -1) {
            gorulenKalemler.push(kalemImza);
            topluKartEkleme.alacakKalemiBilgileri.push(alacakKalemleriBilgisi);
          }
        });

        return {
          args: [topluKartEkleme],
          status: "WAITING",
          type_id: 5
        };
      });

      // Send batch requests
      this.$http.post('/api/v1/toplu-job', {
        data: batchRequests
      }).then(response => {
        console.log('response-->',response.data)
        const createdAt = response?.data?.created_at ?? response?.created_at ?? null;
        if (firstCreatedAt === null && createdAt) {
          firstCreatedAt = createdAt;
          this.getJobDetails(firstCreatedAt);
          this.intervalId = window.setInterval(() => {
            this.getJobDetails(firstCreatedAt);
          }, 10000);
        }

        processedCount += batch.length;
        console.log(`Batch ${batchIndex + 1}/${batches.length} processed. Total progress: ${processedCount}/${totalGroups}`);

        if (processedCount === totalGroups) {
          console.log("All batches have been processed");
        }
      }).catch(error => {
        console.error(`Error processing batch ${batchIndex + 1}:`, error);
        this.$toast.error(
          `Toplu takip açma işleminde hata oluştu.\n\nLütfen Excel şablonunun standart olduğundan emin olun.\nHata devam ederse destek ekibiyle iletişime geçin.`,
          { duration: 8000 }
        );
      });
    });

    this.e1 = 3;

    // eksikAlanlar bir OBJE (index → hatalar); eski kod dizi sanıp .forEach çağırıyordu →
    // sessiz TypeError. Hatalı satır var mı yok mu tek kontrolle belirlenir.
    const hataliSatirVar = Object.keys(this.eksikAlanlar).some(
      (k: string) => Array.isArray(this.eksikAlanlar[k]) && this.eksikAlanlar[k].length > 0
    );
    this.disableTopluTakip = hataliSatirVar;
    this.tooltipInfo = hataliSatirVar;
  }

  // --- Aktarım ilerleme göstergesi (Faz: loading UX) ---
  get toplamDosya(): number {
    return this.tamamlananDosyalar + this.siradaDosyalar + this.hataliDosyalar;
  }
  get islenenDosya(): number {
    return this.tamamlananDosyalar + this.hataliDosyalar;
  }
  // --- Bekleme cubugu (geri sayim) ---
  // Otomatik isleyici dakikada bir calisir; bekleme fazinda bar 100'den 0'a dogru bosalir
  // (sagdan sola), islem baslayinca normal ilerleme (soldan saga) devralir.
  readonly geriSayimSaniye = 60;
  // Geri sayim bittikten sonra gercek isleme baslamamissa gosterilecek ileri yonlu animasyon
  // suresi (sn). 0 = kapali; gercek ilerleme disinda sahte hareket gosterilmez, bar dogrudan
  // belirsiz moda gecer. Yalnizca gecisi gormek icin gecici olarak 15 yapilabilir.
  readonly testIleriGecisSaniye = 0;

  // Bekleme fazinda kalan sure (sn) ve bar yuzdesi (100 -> 0).
  get beklemeKalanSaniye(): number {
    return Math.max(0, this.geriSayimSaniye - this.gecenSaniye);
  }
  get beklemeYuzde(): number {
    return Math.round((this.beklemeKalanSaniye / this.geriSayimSaniye) * 100);
  }
  // Geri sayim bitti ama gercek isleme henuz baslamadi: test amacli ileri animasyon.
  get testGecisAktif(): boolean {
    return !this.islemBasladiMi
      && this.testIleriGecisSaniye > 0
      && this.gecenSaniye >= this.geriSayimSaniye
      && this.gecenSaniye < this.geriSayimSaniye + this.testIleriGecisSaniye;
  }
  get testGecisYuzde(): number {
    const gecen = this.gecenSaniye - this.geriSayimSaniye;
    return Math.min(100, Math.round((gecen / this.testIleriGecisSaniye) * 100));
  }

  // Ekranda gosterilecek bar yuzdesi: bekleme -> geri sayim, test gecisi -> ileri, sonra gercek ilerleme.
  get barYuzde(): number {
    if (this.islemBasladiMi || this.aktarimBitti) return this.ilerlemeYuzde;
    if (this.testGecisAktif) return this.testGecisYuzde;
    return this.beklemeYuzde;
  }
  // Geri sayim bitti, test gecisi de bittiyse ve isleyici hala baslamadiysa: belirsiz mod
  // (bar 0'da takili kalmasin, "duruyor" izlenimi vermesin).
  // Beklemede 90 sn'yi asti: isleyici muhtemelen baska aktarimlarla mesgul.
  get beklemeUzadi(): boolean {
    return !this.islemBasladiMi && !this.aktarimBitti && this.gecenSaniye >= 90;
  }

  // Overlay'i kapatir ama isi birakmaz: yoklama surer, bitince bildirilir.
  arkaPlanaAl(): void {
    this.arkaPlandaTakip = true;
    this.loadingAktar = false;
    if (this.sayacIntervalId) { clearInterval(this.sayacIntervalId); this.sayacIntervalId = null; }
    this.$toast.info('Aktarım arka planda sürüyor; tamamlanınca bilgilendirileceksiniz.');
  }

  get barBelirsiz(): boolean {
    return !this.islemBasladiMi && !this.aktarimBitti && !this.testGecisAktif
      && this.beklemeKalanSaniye === 0;
  }

  get barRengi(): string {
    if (this.aktarimBitti) return 'green';
    if (this.islemBasladiMi || this.testGecisAktif) return 'primary';
    return 'blue-grey lighten-1';
  }

  get ilerlemeYuzde(): number {
    return this.toplamDosya > 0 ? Math.round((this.islenenDosya / this.toplamDosya) * 100) : 0;
  }
  // Sırada bekleyen kalmadıysa aktarım bitmiştir (hepsi hatalı olsa bile).
  get aktarimBitti(): boolean {
    return this.toplamDosya > 0 && this.siradaDosyalar === 0;
  }
  // En az bir dosya işlendiyse (tamamlandı/hatalı) işleyici başlamıştır; öncesinde "başlama bekleniyor".
  get islemBasladiMi(): boolean {
    return this.islenenDosya > 0;
  }

  // Aktarım tamamlandıktan sonra kullanıcı "Tamam"a basınca ekranı kapatır ve başa döner.
  aktarimKapat(): void {
    this.loadingAktar = false;
    this.e1 = 1;
    this.excelFile = null;
    this.items = [];
    this.eksikAlanlar = {};
    this.tamamlananDosyalar = 0;
    this.siradaDosyalar = 0;
    this.hataliDosyalar = 0;
    if (this.sayacIntervalId) { clearInterval(this.sayacIntervalId); this.sayacIntervalId = null; }
    this.gecenSaniye = 0;
    this.arkaPlandaTakip = false;
  }

  getJobDetails(createdAt:string) {
    if (!createdAt) {
      console.warn('getJobDetails: createdAt boş, istek atlanıyor.');
      return;
    }
    // Arka plan takibinde overlay kapali kalmali; yoklama devam eder.
    if (!this.arkaPlandaTakip) {
      this.loadingAktar = true;
    }
    this.$http.get('/api/v1/job-details/', {
      params: {
        create: createdAt,
      }
    }).then((res: any) => {
      this.tamamlananDosyalar = res.tamamlanan_sayisi;
      this.siradaDosyalar = res.sirada_olan_sayisi;
      this.hataliDosyalar = res.hatali_sayisi;
    }).finally(()=>{
      // Sırada bekleyen kalmadıysa (hepsi hatalı olsa bile) aktarım bitmiştir.
      // Eski koşul "tamamlanan>0" idi; hepsi hatalı olduğunda ekran sonsuza takılıyordu.
      // Ekranı hemen kapatmıyoruz: overlay "Tamamlandı" durumunu gösterir, kullanıcı
      // sonucu görüp "Tamam"a basınca kapanır (aktarimKapat).
      const bitti = this.toplamDosya > 0 && this.siradaDosyalar == 0;
      // İşleme başladıysa (veya bittiyse) başlama-bekleme sayacını durdur.
      if ((this.islenenDosya > 0 || bitti) && this.sayacIntervalId) {
        clearInterval(this.sayacIntervalId);
        this.sayacIntervalId = null;
      }
      if (bitti) {
        clearInterval(this.intervalId);
        if (this.tamamlananDosyalar > 0 && this.hataliDosyalar > 0) {
          this.$toast.info(`${this.tamamlananDosyalar} takip aktarıldı, ${this.hataliDosyalar} dosya hatalı.`);
        } else if (this.tamamlananDosyalar > 0) {
          this.$toast.success("Excel Takip Açma Başarıyla Gerçekleşmiştir.");
        } else {
          this.$toast.warning("Aktarım tamamlandı ancak dosyalar hatalı; kayıt oluşmadı.");
        }
        // Kullanici ekrani kapatip arka plana aldiysa sonucu toast ile aldi; durumu sifirla.
        if (this.arkaPlandaTakip) {
          this.aktarimKapat();
        }
      }
    })
  }

  @Watch('excelFile')
  changeExcelFile() {
    if (this.excelFile == null) {
      this.listTable = false
      this.disableTopluTakip = false
      this.tooltipInfo = false
      this.items = [];
      this.kontrolItems = [];
      this.ekAlanBasliklari = [];
    }else{
      this.dragover = false
    }
  }


  async parseExcelData() {
    if (!this.excelFile) {
      this.$toast.error("Lütfen bir Excel dosyası seçiniz.");
      return;
    }
    this.eksikAlanlar = {}

    if (!this.headers || this.headers.length === 0) {
      console.error("Headers are not defined.");
      return;
    }

    const reader = new FileReader();
    reader.readAsArrayBuffer(this.excelFile);

    reader.onload = async (e: ProgressEvent<FileReader>) => {
      const arrayBuffer = e.target?.result as ArrayBuffer;

      if (!arrayBuffer) {
        this.$toast.error("Excel dosyası okunamadı.");
        return;
      }

      try {
        // Tarihleri Date objesine çevirmiyoruz: XLS/XLSX -> Date dönüşümü saat dilimine
        // göre günü bir gün kaydırabiliyor. Standart tarih sütunlarındaki Excel seri
        // numarası aşağıda SSF ile doğrudan takvim gününe çevrilir. cellNF, dinamik
        // ek-alanlarda yalnız gerçekten tarih biçimli sayıları ayırt etmek için gerekir.
        const workbook = XLSX.read(arrayBuffer, {type: 'array', cellDates: false, cellNF: true});
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const workbookDate1904 = !!(
          workbook.Workbook
          && workbook.Workbook.WBProps
          && workbook.Workbook.WBProps.date1904
        );

        // Header validasyonu - standart şablon kontrolü
        const normalizeHeader = (text: string) => text.toLowerCase().replace(/\s+/g, '').trim();
        const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1');
        const uploadedHeaders: string[] = [];
        const uploadedHeaderColumns: Record<string, number> = {};

        for (let col = range.s.c; col <= range.e.c; col++) {
          const cellAddress = XLSX.utils.encode_cell({ r: range.s.r, c: col });
          const cell = worksheet[cellAddress];
          if (cell && cell.v) {
            const baslik = String(cell.v);
            uploadedHeaders.push(baslik);
            uploadedHeaderColumns[normalizeHeader(baslik)] = col;
          }
        }

        // Standart şablon kontrolü
        const expectedHeaders = this.headers
          .filter((h: any) => h.value !== 'remove' && h.value !== 'duzenle' && h.value !== 'status')
          .map((h: any) => h.text);

        const uploadedNormalized = uploadedHeaders.map(h => normalizeHeader(h));
        const expectedNormalized = expectedHeaders.map((h: string) => normalizeHeader(h));

        const missingHeaders = expectedNormalized.filter(
          (expected: string) => !uploadedNormalized.includes(expected)
        );

        if (missingHeaders.length > 0) {
          const originalMissing = missingHeaders.map((missing: string) => {
            const original = expectedHeaders.find((h: string) => normalizeHeader(h) === missing);
            return original || missing;
          });

          this.$toast.error(
            `Excel şablonu hatalı!\n\nEksik sütunlar: ${originalMissing.join(', ')}\n\nLütfen "Örnek Excel İndir" butonundan standart şablonu kullanın.`,
            { duration: 8000 }
          );
          this.excelFile = null;
          return;
        }

        // Ek-alan başlıkları: standart sütunlarda OLMAYAN yüklenen başlıklar (sırayı koru, max 6).
        // Kullanıcı "Ek Alan 1..6" başlıklarını istediği isimle değiştirebilir; gerçek başlık alınır.
        const ekAlanBasliklari = uploadedHeaders.filter(
          (h) => !expectedNormalized.includes(normalizeHeader(h)) && String(h).trim() !== ''
        );
        if (ekAlanBasliklari.length > this.ekAlanMax) {
          this.$toast.warning(
            `En fazla ${this.ekAlanMax} ek alan desteklenir. Fazlası yok sayıldı.`,
            { duration: 6000 }
          );
        }
        this.ekAlanBasliklari = ekAlanBasliklari.slice(0, this.ekAlanMax);

        // raw:true -> Excel tarih seri numarası ve diğer sayılar number olarak korunur.
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {raw: true});

        if (jsonData.length > 0) {
          this.items = [];

          jsonData.forEach((row: any, rowIndex: number) => {
            const item: any = {};

            this.headers.forEach((header:any) => {
              const normalizedHeader = header.text.toLowerCase().replace(/\s+/g, "").trim();
              const matchingKey = Object.keys(row).find(key =>
                  key.toLowerCase().replace(/\s+/g, "").trim() === normalizedHeader
              );

              if (matchingKey) {
                let cellValue = row[matchingKey];

                // Standart tarih alanları: number (Excel serial) veya farklı string
                // formatları (5.06.2026, 5.06.2026 10:35:41, 5/6/2026...) backendin
                // beklediği GG/AA/YYYY (saatsiz) formatına çevrilir.
                const tarihAlanlari = [
                  'faiz_baslangic_tarihi',
                  'vade_tarihi',
                  'takip_tarihi',
                  'donem_baslama_tarih'
                ];
                if (tarihAlanlari.indexOf(header.value) !== -1) {
                  cellValue = this.normalizeStandartTarih(cellValue, workbookDate1904);
                }

                item[header.value] = cellValue;
              } else {
                item[header.value] = '';
              }

            });

            // Ek-alanlar: gerçek başlık metnine göre değer eşleştir (pozisyon/isim dinamik).
            // Değer tarih olarak çözülebiliyorsa tür "date" + değer ISO (YYYY-MM-DD),
            // aksi halde tür "text" + ham metin. Sayısal değer yalnız kaynak hücrenin
            // Excel biçimi tarihse seri tarih kabul edilir; düz sayı (251) tarih DEĞİL.
            item._ekAlanlar = this.ekAlanBasliklari.map((baslik: string) => {
              const normBaslik = normalizeHeader(baslik);
              const matchingKey = Object.keys(row).find(
                (key) => normalizeHeader(key) === normBaslik
              );
              const rawDeger = matchingKey != null ? row[matchingKey] : '';
              const sourceCol = uploadedHeaderColumns[normBaslik];
              const sourceRow = typeof row.__rowNum__ === 'number'
                ? row.__rowNum__
                : range.s.r + 1 + rowIndex;
              const sourceCell = sourceCol === undefined
                ? null
                : worksheet[XLSX.utils.encode_cell({r: sourceRow, c: sourceCol})];
              const excelTarihHucresi = !!(
                sourceCell
                && sourceCell.t === 'n'
                && sourceCell.z
                && XLSX.SSF.is_date(sourceCell.z)
              );
              const isoTarih = this.parseEkAlanTarih(rawDeger, excelTarihHucresi, workbookDate1904);
              const tur = isoTarih !== null ? 'date' : 'text';
              const deger = isoTarih !== null
                ? isoTarih
                : (rawDeger == null ? '' : String(rawDeger).trim());
              return {
                isim: String(baslik).trim(),
                kod: this.ekAlanKod(String(baslik).trim()),
                tur,
                deger
              };
            });

            // Enum sütunlarını kanonik forma çevir ("evet"→"EVET"): backend tam eşleşme
            // beklediği için burada normalize edilir; çözülemeyen değer olduğu gibi kalır
            // ve aşağıdaki satiriDogrula onu "geçersiz değer" olarak işaretler.
            enumAlanlariNormalizeEt(item);
            // Cinsiyeti kanonik E/K'ya indir (Excel'de ERKEK/Erkek/bay gibi gelebilir) — dropdown
            // ERKEK/KADIN gösterir, backend'e E/K gider.
            item.borclu_cinsiyet = cinsiyetNormalize(item.borclu_cinsiyet);
            // Faiz türü: Excel'deki sıra numarasını isme çevir (backend isimle çözüyor).
            item.takip_oncesi_faiz_turu = faizSirasiniIsmeCevir(item.takip_oncesi_faiz_turu);
            item.takip_sonrasi_faiz_turu = faizSirasiniIsmeCevir(item.takip_sonrasi_faiz_turu);
            // Kilitli alanları (takip tipi = İlamsız/49) sabitle: hücre düzenlenemediği için
            // Excel'den boş/hatalı gelen değer aksi halde düzeltilemez bir hataya dönüşürdü.
            this.kilitliAlanlariUygula(item);

            this.items.push(item);
          });

          // Satır doğrulama artık merkezi excelSema.satiriDogrula ile yapılıyor:
          // boş-zorunlu + tip/format (tarih, sayı, TC/vergi, enum) + koşullu kurallar.
          // Eski satır-içi eksikAlanlar döngüsünün "EVET+ORAN diğer alanları atlıyor"
          // kusuru giderildi; hata mesajları artık nedeniyle birlikte (HucreHatasi) tutulur.
          // Yeni obje kurup topluca atıyoruz: Vue 2 objeye tek tek key eklemeyi reaktif
          // izlemez; doğrudan atama hataOzeti gibi computed'ları güncellemiyordu.
          const yeniEksikAlanlar: any = {};
          this.items.forEach((item: any, index: any) => {
            const hatalar = satiriDogrula(item);
            if (hatalar.length > 0) {
              yeniEksikAlanlar[index] = hatalar;
            }
          });
          this.eksikAlanlar = yeniEksikAlanlar;

          // İl/ilçe ham değerlerini kanonik DB ismine çevir (arka planda; kullanıcı canonical görür).
          this.ilIlceNormalizeEt();

        } else {
          this.$toast.error("Excel dosyası boş veya geçersiz format.");
        }
      } catch (error) {
        console.error("Error parsing Excel file: ", error);
        this.$toast.error(
          "Excel dosyası işlenirken hata oluştu. Lütfen standart şablonu kullandığınızdan emin olun.",
          { duration: 6000 }
        );
        this.excelFile = null;
      }
    };

    reader.onerror = (error) => {
      console.error("File reading error: ", error);
      this.$toast.error("Dosya okuma hatası. Lütfen farklı bir dosya deneyin.");
      this.excelFile = null;
    };
  }

  onDrop(event:any) {
    this.dragover = false;
    const files = event.dataTransfer.files;

    if (files.length > 0) {
      const file = files[0]; // İlk dosyayı al

      // Dosya uzantısını kontrol et
      const uzanti = file.name.split(".").pop();
      if (["xlsx", "XLSX", "xls", "XLS"].indexOf(uzanti) >= 0) {
        this.excelFile = file;
        this.onFileChange(file);
      } else {
        // Hata mesajı göster
        this.$emit('error', "Sadece excel dosya yüklenebilir.");
      }
    }
  }

  fileRule(file: File): boolean | string {
    if (file) {
      let uzanti = file.name.split(".").pop();
      if (["xlsx", "XLSX", "xls", "XLS"].indexOf(uzanti!) >= 0) return true;
      else return "Sadece excel dosya yüklenebilir.";
    } else return "Lütfen bu alanı doldurun.";
  }

  onFileChange(file: File) {
    if (file) {
      this.fileName = file.name;
    }
  }
}
